var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-chip',{attrs:{"text-color":_vm.statusTextColor(_vm.isPublish),"color":_vm.statusFillColor(_vm.isPublish),"dark":""}},[_vm._v(" "+_vm._s(_vm.statusName(_vm.isPublish))+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }